<script setup lang="ts">
import { computed } from 'vue';
import { useTranslation } from 'i18next-vue';

import type { AppNotification } from '../types/notifications.types';
import {
  getNotificationDescription,
  getNotificationTitle,
} from '../utils/notificationPresentation';

defineOptions({ name: 'NotificationRowMessageContent' });

interface Props {
  notification: AppNotification;
  formattedTime: string;
}

const { notification, formattedTime } = defineProps<Props>();

const { t } = useTranslation();

const title = computed(() => getNotificationTitle(notification, t));
const description = computed(() => getNotificationDescription(notification));
</script>

<template>
  <p class="notification-message__title">{{ title }}</p>
  <p v-if="formattedTime.length > 0" class="notification-message__date">{{ formattedTime }}</p>
  <p class="notification-message__description">{{ description }}</p>
</template>
